import $ from 'jquery';
import { gsap } from 'gsap';

const $items = $('.alt-gallery-item');
const strength = 150;

$(document).on('mousemove', (e: JQuery.MouseMoveEvent) => {
  $items.each((_index: number, item: HTMLElement) => {
    const $item = $(item);
    const $inner = $item.find('.magnet-wrap');
    const rect = item.getBoundingClientRect();

    const itemX = rect.left + rect.width / 2;
    const itemY = rect.top + rect.height / 2;

    const distX = e.clientX - itemX;
    const distY = e.clientY - itemY;

    const distance = Math.sqrt(distX * distX + distY * distY);

    if (distance < strength) {
      gsap.to($inner[0], {
        x: distX * 0.3,
        y: distY * 0.3,
        duration: 0.3,
        ease: 'power3.out',
      });
    } else {
      gsap.to($inner[0], {
        x: 0,
        y: 0,
        duration: 0.5,
        ease: 'elastic.out(1, 0.4)',
      });
    }
  });
});
